/**
 * violex-edition.js — Interaktion der Editions-Produktseite.
 * Gehoert zu sections/violex-edition.liquid + assets/violex-edition.css.
 *
 * Bewusst eigene Hooks (data-vxe-*) statt der globalen data-violex-*:
 * violex-product-cart.js bindet sich beim Laden an JEDES
 * [data-violex-add-to-cart] im Dokument. Gleiche Attribute hier wuerden
 * bedeuten, dass beide Skripte auf denselben Klick reagieren - also zwei
 * /cart/add.js-Requests und zwei Artikel im Warenkorb.
 *
 * Unterschiede zum alten violex-product-cart.js, alle drei aus dem UX-Audit:
 *  1. Groessen als Buttons statt Dropdown - Verfuegbarkeit auf einen Blick
 *     (Audit Punkt 6). Das <select> bleibt die Quelle der Wahrheit.
 *  2. Die Antwort von /cart/add.js wird AUSGEWERTET. Vorher wurde sie
 *     verworfen: ein in der Sekunde ausverkaufter Artikel sah aus wie ein
 *     Erfolg (Audit Punkt/Analyse 2.3).
 *  3. Die Bestaetigung bleibt stehen, statt nach 1.8s zu verschwinden, und
 *     enthaelt den Weg weiter (Audit Punkt 2).
 *
 * KORREKTUR (Slide-in-Warenkorb, Phase 2): dispatcht seitdem zusaetzlich
 * "violex:cart:add" mit dem vollen Item aus der /cart/add.js-Antwort, damit
 * assets/violex-cart-drawer.js auch von HIER aus das Panel oeffnen kann - die
 * Inline-Bestaetigung unten bleibt trotzdem bestehen (kein Widerspruch, beide
 * zusammen: sofortiges Feedback am Button UND der Fortschritt/die
 * Zwischensumme im Panel).
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-vxe-picker]').forEach(setupPicker);
    setupLightbox();
    setupFigureNav();
  });

  // ── Bild-Navigation (vor/zurueck durch alle Produktfotos) ───────────────────
  // 29.08.2026, Wunsch Igor: "links/rechts waehlen koennen, um auf alle 5
  // Produktbilder zuzugreifen, nicht nur zwischen zwei wechseln" - ersetzt
  // die alte binaere Vorder-/Rueckseiten-Umschaltung (setupTurnButton/
  // is-back) durch einen echten Index, der beliebig viele Bilder traegt.
  // Vier moegliche Ausloeser (Pfeil-Buttons neben dem Produktfoto UND, siehe
  // Wunsch Tomas 29.08.2026 "auch im Vergroesserungs-Modus wechseln
  // koennen", im Lightbox-Overlay) - ein gemeinsames showIndex() haelt alle
  // synchron. Bei genau 2 Bildern (Day/Night Edition) verhaelt sich das
  // exakt wie vorher, nur ueber zwei Pfeile statt eines Umschalt-Knopfs.
  function setupFigureNav() {
    var figures = document.querySelector('[data-vxe-figures]');
    if (!figures) return;

    var items = Array.prototype.slice.call(figures.querySelectorAll('.vxe__figure'));
    var count = items.length;
    if (count === 0) return;

    var prevBtn = document.querySelector('[data-vxe-prev]');
    var nextBtn = document.querySelector('[data-vxe-next]');
    var lightboxPrevBtn = document.querySelector('[data-vxe-lightbox-prev]');
    var lightboxNextBtn = document.querySelector('[data-vxe-lightbox-next]');

    var current = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains('is-active')) { current = i; break; }
    }

    function showIndex(target) {
      current = ((target % count) + count) % count;
      items.forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === current);
      });

      var lightboxImg = document.querySelector('[data-vxe-lightbox] img');
      var lightboxOpen = document.querySelector('[data-vxe-lightbox].is-open');
      if (lightboxOpen && lightboxImg) {
        var activeItem = items[current];
        var inner = activeItem.querySelector('img');
        lightboxImg.src = activeItem.dataset.vxeZoom;
        lightboxImg.alt = inner ? inner.alt : '';
      }
    }

    function goNext() { showIndex(current + 1); }
    function goPrev() { showIndex(current - 1); }

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (lightboxPrevBtn) lightboxPrevBtn.addEventListener('click', goPrev);
    if (lightboxNextBtn) lightboxNextBtn.addEventListener('click', goNext);
  }

  function setupPicker(root) {
    var select = root.querySelector('[data-vxe-variant-select]');
    var sizeWrap = root.querySelector('[data-vxe-sizes]');
    var priceEl = root.querySelector('[data-vxe-price]');
    var addBtn = root.querySelector('[data-vxe-add]');
    var feedback = root.querySelector('[data-vxe-feedback]');
    var swatches = root.querySelectorAll('[data-vxe-swatch]');

    if (!addBtn) return;

    var orderUrl = root.dataset.orderUrl || '/pages/order';

    // ── Groessen-Buttons aus den <option>s bauen ─────────────────────────────
    // Aus derselben Liste, aus der auch das <select> besteht - es gibt keine
    // zweite Aufzaehlung im Markup, die davon abweichen koennte.
    if (select && sizeWrap) {
      Array.prototype.forEach.call(select.options, function (option) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vxe__size';
        // option.text enthaelt bei ausverkauften Varianten den Zusatz
        // "— Ausverkauft"; auf dem Knopf reicht der reine Optionswert, die
        // Nichtverfuegbarkeit zeigt der disabled-Zustand (durchgestrichen).
        btn.textContent = option.dataset.option1 || option.text;
        btn.dataset.value = option.value;
        btn.disabled = option.dataset.available !== 'true';
        btn.setAttribute('aria-pressed', option.selected ? 'true' : 'false');
        if (btn.disabled) {
          btn.setAttribute(
            'aria-label',
            (option.dataset.option1 || option.text) + ' — ' + (addBtn.dataset.soldOutText || 'Ausverkauft'),
          );
        }
        btn.addEventListener('click', function () {
          select.value = option.value;
          // 'change' feuern, damit unten genau derselbe Pfad laeuft wie bei
          // einer Bedienung des <select> selbst (Tastatur, ohne JS-Buttons).
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        sizeWrap.appendChild(btn);
      });
    }

    function syncFromSelect() {
      if (!select) return;
      var option = select.options[select.selectedIndex];
      if (!option) return;

      var available = option.dataset.available === 'true';
      addBtn.dataset.variantId = option.value;
      addBtn.disabled = !available;
      addBtn.textContent = available
        ? addBtn.dataset.defaultText || 'In den Warenkorb'
        : addBtn.dataset.soldOutText || 'Ausverkauft';

      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;

      if (sizeWrap) {
        sizeWrap.querySelectorAll('.vxe__size').forEach(function (btn) {
          btn.setAttribute('aria-pressed', btn.dataset.value === select.value ? 'true' : 'false');
        });
      }

      swatches.forEach(function (sw) {
        sw.classList.toggle('is-active', sw.dataset.vxeSwatch === (option.dataset.option1 || ''));
      });

      // Wechselt die Variante, ist die alte Bestaetigung nicht mehr gueltig -
      // sonst steht "Grösse M hinzugefügt", waehrend L ausgewaehlt ist.
      hideFeedback();
    }

    if (select) select.addEventListener('change', syncFromSelect);

    // ── Farbfelder, die echte Varianten schalten ────────────────────────────
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (!select) return;
        var wanted = sw.dataset.vxeSwatch;
        var match = Array.prototype.find.call(select.options, function (o) {
          return o.dataset.option1 === wanted;
        });
        if (!match) return;
        if (match.dataset.available !== 'true') {
          showFeedback((sw.getAttribute('aria-label') || 'Diese Farbe') + ' ist zurzeit nicht verfügbar.', true);
          return;
        }
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    syncFromSelect();

    // ── In den Warenkorb ────────────────────────────────────────────────────
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var variantId = addBtn.dataset.variantId;
      if (!variantId) return;

      var restoreText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = addBtn.dataset.addingText || 'Wird hinzugefügt …';
      hideFeedback();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        // Bewusst .text() + eigenes JSON.parse statt res.json(): kommt keine
        // JSON-Antwort zurueck (Shopify-Fehlerseite, Proxy, Wartungsseite),
        // wirft res.json() eine Parser-Meldung wie
        // "Unexpected token '<'" - und die stand dann woertlich als
        // Fehlermeldung vor dem Kunden. Beim Testen genau so passiert.
        .then(function (res) {
          return res.text().then(function (raw) {
            var data = null;
            try {
              data = JSON.parse(raw);
            } catch (e) {
              data = null;
            }

            // Shopify antwortet auf einen nicht (mehr) lieferbaren Artikel mit
            // 422 und einer fertigen, uebersetzten Meldung in data.description.
            // Genau die wurde vom alten violex-product-cart.js weggeworfen.
            if (!res.ok) {
              throw customerError((data && (data.description || data.message)) || genericError());
            }
            if (!data) {
              throw customerError(genericError());
            }
            return data;
          });
        })
        .then(function (data) {
          addBtn.textContent = restoreText;
          addBtn.disabled = false;
          showAdded();
          // Slide-in-Panel (assets/violex-cart-drawer.js) hoert global auf
          // dieses Event - volles Item aus der Antwort, kein Zusatz-Request.
          document.dispatchEvent(
            new CustomEvent('violex:cart:add', { detail: { item: data.items && data.items[0] } }),
          );
          return updateCartCount();
        })
        .catch(function (error) {
          addBtn.textContent = restoreText;
          addBtn.disabled = false;
          // Nur selbst formulierte Meldungen anzeigen. Alles andere (z.B.
          // "Failed to fetch" bei fehlender Verbindung) ist eine technische
          // Notiz fuer die Konsole, keine Auskunft fuer den Kunden.
          showFeedback(error && error.customerSafe ? error.message : genericError(), true);
          if (!error || !error.customerSafe) console.error('Add to cart failed', error);
        });
    });

    /** Auffangmeldung, wenn der Server nichts Verwertbares geliefert hat.
     *  Aus dem Section-Setting, damit sie ohne Code-Aenderung anpassbar und
     *  uebersetzbar ist. */
    function genericError() {
      return (
        addBtn.dataset.errorText ||
        'Der Artikel konnte nicht hinzugefügt werden. Bitte lade die Seite neu und versuch es nochmal.'
      );
    }

    /** Markiert eine Meldung als "darf dem Kunden gezeigt werden" - siehe
     *  catch() oben. */
    function customerError(message) {
      var error = new Error(message);
      error.customerSafe = true;
      return error;
    }

    function currentSizeLabel() {
      if (!select) return '';
      var option = select.options[select.selectedIndex];
      var value = option && (option.dataset.option1 || '');
      return value && value !== 'Default Title' ? value : '';
    }

    function showAdded() {
      var size = currentSizeLabel();
      var headline = size ? 'Grösse ' + size + ' liegt im Warenkorb.' : 'Liegt im Warenkorb.';

      feedback.className = 'vxe__feedback is-visible';
      feedback.textContent = '';

      var line = document.createElement('div');
      line.textContent = '✓ ' + headline;
      feedback.appendChild(line);

      var actions = document.createElement('div');
      actions.className = 'vxe__feedback-actions';

      var toCart = document.createElement('a');
      toCart.className = 'vxe__feedback-link';
      toCart.href = orderUrl;
      toCart.textContent = 'Zum Warenkorb →';
      actions.appendChild(toCart);

      feedback.appendChild(actions);
    }

    function showFeedback(message, isError) {
      feedback.className = 'vxe__feedback is-visible' + (isError ? ' is-error' : '');
      feedback.textContent = message;
    }

    function hideFeedback() {
      if (!feedback) return;
      feedback.className = 'vxe__feedback';
      feedback.textContent = '';
    }
  }

  /**
   * Zaehler im Header nachziehen. Der Header rendert ihn serverseitig, nach
   * einem fetch()-Warenkorb-Update steht dort sonst eine veraltete Zahl - und
   * eine falsche Zahl am Warenkorb ist schlimmer als gar keine.
   */
  function updateCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('vx-nav-cart-count');
        if (!el) return;
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
        el.setAttribute('aria-label', cart.item_count + ' Artikel im Warenkorb');
        document.dispatchEvent(
          new CustomEvent('violex:cart:updated', { detail: { count: cart.item_count } }),
        );
      })
      .catch(function () {
        // Zaehler ist Beiwerk - ein Fehler hier darf die Bestaetigung nicht
        // in eine Fehlermeldung verwandeln.
      });
  }

  // ── Lightbox ──────────────────────────────────────────────────────────────
  function setupLightbox() {
    var box = document.querySelector('[data-vxe-lightbox]');
    if (!box) return;
    var img = box.querySelector('img');
    var closeBtn = box.querySelector('[data-vxe-lightbox-close]');
    var lastFocused = null;

    function open(src, alt) {
      lastFocused = document.activeElement;
      img.src = src;
      img.alt = alt || '';
      box.classList.add('is-open');
      box.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      if (!box.classList.contains('is-open')) return;
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden', 'true');
      img.src = '';
      document.body.style.overflow = '';
      // Fokus dorthin zurueck, wo er herkam - sonst landet die Tastatur nach
      // dem Schliessen wieder am Seitenanfang.
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    document.querySelectorAll('[data-vxe-zoom]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var inner = trigger.querySelector('img');
        open(trigger.dataset.vxeZoom, inner ? inner.alt : '');
      });
    });

    closeBtn.addEventListener('click', close);
    box.addEventListener('click', function (event) {
      if (event.target === box) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }
})();
